export default {
  'menu.welcome': 'Хулоса',
  'menu.dashboard': 'Хулоса',
  'menu.monitoring': 'Мониторинг',
  'menu.communicationsList': 'Рӯйхати коммуникатсияҳо',
  'menu.communicationEditor': 'Муҳаррири коммуникатсия',
  'menu.school': 'Мактаб',
  'menu.login': 'Ворид шудан',
  'menu.register': 'Сабти ном',
  'menu.user': 'Корбар',
  'menu.profile': 'Профил',
  'menu.list': 'Рӯйхат',
  'menu.users': 'Корбарон',
  'menu.roles': 'Нақшҳо',
  'menu.infrastructure': 'Инфрасохтор',
  'menu.infrastructure.users': 'Корбарон',
  'menu.infrastructure.usersCards': 'Корбарон (Кортҳо)',
  'menu.infrastructure.roles': 'Нақшҳо',
  'menu.subject': 'Субъектҳо',
  'menu.subject.subjectTypes': 'Намудҳои субъект',
  'menu.subject.subjects': 'Субъектҳо',
  'menu.subject.organizations': 'Ташкилотҳо',

  // @generated entity-menu
  'menu.communication': 'Коммуникатсия',
  'menu.communication.communication': 'Коммуникатсия',
  'menu.communication.communicationDetail': 'Тафсилоти коммуникатсия',
  'menu.communication.communicationFolder': 'Ҷӯрчуби коммуникатсия',
  'menu.communication.communicationHistory': 'Таърихи коммуникатсия',
  'menu.communication.communicationPermission': 'Иҷозоти коммуникатсия',
  'menu.communication.communicationStrategy': 'Стратегияи коммуникатсия',
  'menu.communication.communicationSubject': 'Субъекти коммуникатсия',
  'menu.communication.communicationVersion': 'Насхи коммуникатсия',
  'menu.communication.communicationView': 'Намоиши коммуникатсия',
  'menu.communication.typeSubjectCommunication': 'Намуди субъекти коммуникатсия',
  'menu.context': 'Контекст',
  'menu.context.promptTemplates': 'Қолабҳои промпт',
  'menu.context.contextClassifier': 'Синфкунандаи контекст',
  'menu.context.contextData': 'Маълумоти контекст',
  'menu.context.contextPipeline': 'Нақбаи контекст',
  'menu.context.contextStorage': 'Захираи контекст',
  'menu.context.groupContextClassifier': 'Гӯруҳи синфкунандаҳо',
  'menu.context.providerContext': 'Контексти таъминкунанда',
  'menu.context.providerContextClassifier': 'Синфкунандаи контексти таъминкунанда',
  'menu.context.resultContextClassifier': 'Натиҷа — синфкунанда',
  'menu.context.shareContextStorage': 'Захираи умумии контекст',
  'menu.context.typeProviderContext': 'Намуди контексти таъминкунанда',
  'menu.context.versionProviderContext': 'Насхи контексти таъминкунанда',
  'menu.infrastructure.permission': 'Иҷозат',
  'menu.infrastructure.role': 'Нақш',
  'menu.infrastructure.user': 'Корбар',
  'menu.services': 'Хидматҳо',
  'menu.services.aiModel': 'Модели ИИ',
  'menu.services.brokerEvent': 'Рӯйдади брокер',
  'menu.services.dataPipeline': 'Нақби маълумот',
  'menu.services.dataPipelineDetail': 'Тафсилоти нақби маълумот',
  'menu.services.dependentVersionService': 'Вобастагии насх',
  'menu.services.detailScheduler': 'Элементи иҷрои ҷадвал',
  'menu.services.historyRunningPipeline': 'Таърихи иҷрои нақб',
  'menu.services.historyRunningStreamPipeline': 'Таърихи услуби ҷараён',
  'menu.services.injectionVersionService': 'Injection Version Service',
  'menu.services.pipeline': 'Нақби коркард',
  'menu.services.resultScheduler': 'Натиҷаи ҷадвал',
  'menu.services.running': 'Намуди иҷро',
  'menu.services.scheduler': 'Ҷадвалгузор',
  'menu.services.schemaPipeline': 'Схемаи нақб',
  'menu.services.service': 'Хизматрасонӣ',
  'menu.services.serviceEvent': 'Рӯйдади хизматрасонӣ',
  'menu.services.serviceParams': 'Параметрҳои хизматрасонӣ',
  'menu.services.serviceType': 'Намуди хизматрасонӣ',
  'menu.services.serviceVersion': 'Насхи хизматрасонӣ',
  'menu.services.testPipeline': 'Нақби санҷиш',
  'menu.services.testResultPipeline': 'Натиҷаи санҷиш',
  'menu.services.tuneModel': 'Вазифаи қайчӣ',
  'menu.services.tuneModelResult': 'Натиҷаи қайчии модел',
  'menu.subject.application': 'Барнома',
  'menu.subject.division': 'Қисмот',
  'menu.subject.individual': 'Шахси воқеӣ',
  'menu.subject.organization': 'Ташкилот',
  'menu.subject.organizationPosition': 'Вазифа дар ташкилот',
  'menu.subject.organizationStructure': 'Сохтори созмонӣ',
  'menu.subject.organizationStructurePermission': 'Дастрасӣ ба сохтор',
  'menu.subject.subject': 'Субъект',
  'menu.subject.subjectType': 'Намуди субъект',
  'menu.subject.userOrganizationStructure': 'Корбар дар сохтор',
};
